import React from 'react';
export function Approval(_ref) {
  var handleConfirm = _ref.handleConfirm;
  return /*#__PURE__*/React.createElement("div", {
    className: "squeak-approval-required"
  }, /*#__PURE__*/React.createElement("h3", null, "Post submitted"), /*#__PURE__*/React.createElement("p", null, "New posts require approval from a moderator. Check back soon!"), /*#__PURE__*/React.createElement("p", null, "(You'll also receive an email when answers are posted.)"), /*#__PURE__*/React.createElement("button", {
    onClick: handleConfirm,
    className: "squeak-post-button"
  }, "Got it"));
}